<template>
    <section class="congrats">
        <rich-pretty-info>
            <template slot="image">
                <img src="../../assets/img/illustrations/success-cours.svg" height="200" width="200"/>
            </template>
            <template slot="content">
                <h1 v-if="!tooManyCourses">
                    Votre demande d'inscription au cours de {{course.course_category.name}} {{ course.name }} a été prise en compte !
                </h1>
                <h1 v-else>
                    Votre demande d'inscription a été prise en compte !
                </h1>
                <p>
                    Votre inscription sera valide une fois que nous aurons réceptionné le paiement et vérifié votre
                    certificat médical.
                </p>
            </template>
            <template slot="actions">
                <uni-cta-link v-if="user.current_courses.length < 3" :to="{name: 'classes.new', params: {id: $route.params.id}}">
                    Inscrire à un cours supplémentaire
                </uni-cta-link>
                <uni-cta-link to="/" class="uni-cta-link--secondary">
                    Retour à l'accueil
                </uni-cta-link>
            </template>
        </rich-pretty-info>
    </section>
</template>

<script>
    import RichPrettyInfo from "../../components/c-blocks/RichPrettyInfo";
    import UniButton from "../../components/a-elements/UniButton";
    import UniCtaLink from "../../components/a-elements/UniCtaLink";

    export default {
        name: "success",
        components: {UniCtaLink, UniButton, RichPrettyInfo},
        data() {
            return {
                user: {},
                course: {},
                tooManyCourses: false
            }
        },
        created() {
            this.$getModel('users', this.$route.params.id)
                .then(data => {
                    this.user = data
                    if (this.$route.params.course_id !== "more") {
                        this.$nextTick(() => {
                            this.$getModel('courses', this.$route.params.course_id)
                                .then(data => {
                                    this.course = data
                                })
                        })
                    } else {
                        this.tooManyCourses = true
                    }

                })
        }
    }
</script>

<style scoped lang="scss">

</style>
